import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RocketOutlinedSvg from "@ant-design/icons-svg/es/asn/RocketOutlined";
import AntdIcon from "../components/AntdIcon";
var RocketOutlined = function RocketOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RocketOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RocketOutlined.displayName = 'RocketOutlined';
}
export default /*#__PURE__*/React.forwardRef(RocketOutlined);